import {environment} from 'src/environments/environment';
import {ToastrService} from 'ngx-toastr';
import {ApiRestService} from '../_service/api-rest.service';
import {ClassicType} from '../../shared/models/ClassicType';
import {Persona} from '../models/persona';
import {RicercaPaginazione} from '../models/sendpersonale';
import {PersonaleStoreService} from '../_service/personale-store.service';
import {FileStoreService} from '../../shared/_services/file-store.service';
import {Router, ActivatedRoute, UrlSegment} from '@angular/router';
import {AziendeStoreService} from '../_service/aziende-store.service';
import {FormBuilder} from '@angular/forms';
import {Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import {Subscription} from 'rxjs';
import {Azienda} from '../models/Azienda';
import {Paginazione} from 'src/app/shared/models/paginazione';
import {Permission} from "../../Login/_guards/Permission";
import {Ruolo} from "../models/Ruolo";
import {Todo} from "../../shared/Checklists/Questionario/questionario.component";
import {Check} from "../../formazione/_Models/Check";
import {ApiPathsService} from "../../api-paths.service";
import {AuthenticationService} from "../../Login/_services/authentication.service";
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";
import {CampoUtility} from "../../shared/models/campo-aggiuntivo";
import {ChangeDetectorRef} from '@angular/core';
import {DynamicCrudService} from 'src/app/shared/_services/dynamic-crud.service';
import {Title} from '@angular/platform-browser';
import {ClientiAddOnConfig} from "../../../environments/BaseEnvironments/Model";
import {Location} from "@angular/common";

@Component({
  selector: 'app-form-azienda',
  templateUrl: './form-azienda.component.html'
})
export class FormAziendaComponent implements OnInit {
  environment = environment;
  env = environment
  subscriptions: Subscription = new Subscription();
  listaNomiClienti: Azienda[] = [];
  listaNomiPersonale: Persona[] = [];
  selected: Azienda = new Azienda();
  dump: string;
  editable: boolean;
  showaddform: boolean;
  submitted: boolean;
  DropdownSources = {};
  ClientiAddOn: ClientiAddOnConfig = environment.ClientiAddOn;
  hasInterventi = (this.ClientiAddOn.interventi == true) && !this.permission.isOperativeRole('C');
  hasRoles = environment.ClientiAddOn.ruolo;
  //multiselect
  ruoliCliente: ClassicType[] = [];
  ruoloCliente: ClassicType[] = [];
  tipologieAsObj: ClassicType[];
  RuoliPredefiniti = environment.ClientiAddOn['RuoliMap'] ?? [];
  tipologie: string[] = null;
  selectedItems: ClassicType[] = [];
  tipologieSedi: ClassicType[] = [];
  tipologieSediSelezionate: ClassicType[] = [];
  segnalatoreselezionato: Azienda[] = [];
  segnalatoreinternoselezionato: Persona[] = [];
  commercialeselezionato: Persona[] = [];
  Readonly: boolean = false;
  ruoloAccessoDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'ruolo',
  };

  RmaListType: 'task' | 'rma' = environment.RmaAddOn['pippo'] == true ? 'task' : 'rma';

  listaruoliaccesso: Ruolo[] = [];
  listaruoliaccessoselezionati: Ruolo[] = [];
  dropdownSettings = {
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    idField: 'id',
    textField: 'label',
    itemsShowLimit: 5,
    allowSearchFilter: true,
  };
  ProvdropdownSettings = {
    singleSelection: true,
    singleOutput: true,
    idField: 'id',
    textField: 'label',
    allowSearchFilter: true,
  };
  clientidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nominativo',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  utentidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'fullName',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  roledropdownSettings = {
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    idField: 'id',
    textField: 'label',
    allowSearchFilter: false,
  };

  closeDropdownSelection = false;
  type: string;
  id: number;
  isActive: boolean;
  CredenzialiGiaInserite: boolean;
  Profilo: boolean;
  ActiveId: string = 'info';
  idCongelamento: number;
  Provincie: any[];
  Provincia: any;
bup: Azienda = undefined;
  onItemSelect(item: any) {
    // console.log(item);
  }

  onSelectAll(items: any) {
    // console.log(items);
  }

  constructor(
    public aziendeStore: AziendeStoreService,
    private personaleStore: PersonaleStoreService,
    private filestore: FileStoreService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private apiRestService: ApiRestService,
    public apiPaths: ApiPathsService,
    private toastService: ToastrService,
    public permission: Permission,
    public toastservice: ToastrService,
    private authenticationService: AuthenticationService,
    public campoUtility: CampoUtility,
    private cdr: ChangeDetectorRef,
    private CrudService: DynamicCrudService,
    private titleservice: Title,
    private location: Location
  ) {
  }

  ngOnInit() {
    this.route.url.subscribe((urlSegments: UrlSegment[]) => {
      this.Profilo = urlSegments[0].path == "profile";
    });
    this.route.params.subscribe(data => {
      this.type = data['type'] != 0 ? data['type'] : null;
      this.id = parseInt(data['id']);
      this.idCongelamento = parseInt(data['idCongelamento']);
      this.Readonly = this.idCongelamento > 0 || !this.permission.HasCapacity(['gestione-clienti']);
      this.ActiveId = data['tab'] ?? 'info';
    })

    if (this.ClientiAddOn['provinciaArray']) {
      this.apiPaths.ClassicGet('/settings/province').subscribe(data => {
        console.log(this.authenticationService.currentUserValue)
        this.Provincie = data.filter(x => !(this.authenticationService.currentUserValue['regioni']?.length > 0) || this.authenticationService.currentUserValue['regioni']?.findIndex(y => y == x.regione_id) > -1)
        this.Provincia = this.Provincie.find(x => x.id == this.selected.provincia)
        console.log("Provincia: ", this.Provincia)
        console.log("Cli: ", this.selected)
      })
    }

    if (this.ClientiAddOn.ruolo) {
      this.apiRestService.getRuoloClienti().subscribe(data => this.ruoliCliente = data);
    }
    if (this.ClientiAddOn.ruoliAccesso && this.ClientiAddOn.ruolo && !this.Profilo)
      this.apiRestService.getRuoliList().subscribe(data => this.listaruoliaccesso = data.data);
    this.personaleStore.updateShowAllUser(false);
    // if (this.ClientiAddOn.sedi)
    this.aziendeStore.getTipologieSedi();
    this.aziendeStore.getTipologieClienti().subscribe((data) => {
      if (data) {
        this.tipologieAsObj = this.permission.isOperativeRole('AG') ? data.filter(x => x['codice'] == 43 || x['codice'] == 1 || x['codice'] == 48) ?? [] : data;
        // if (this.selectedItems?.length < 1 && data.length > 0 && this.type != "f")
        //   this.selectedItems.push(data[0]);
      }
    });
    this.RmaListType = environment.RmaAddOn['pippo'] == true ? 'task' : 'rma';
    console.log('RmaListType: ', this.RmaListType)
    this.subscriptions.add(this.aziendeStore.$listaAziende.subscribe((items) => {
      if (items && items !== null)
        this.listaNomiClienti = items.data
    }));
    this.subscriptions.add(this.personaleStore.$listaPersonale.subscribe((items) => {
      if (items && items !== null)
        this.listaNomiPersonale = items.data
    }));
    this.subscriptions.add(this.aziendeStore.$tipologieSedi.subscribe((items) => {
      if (items) {
        this.tipologieSedi = items;
        if (this.tipologieSediSelezionate?.length < 1 && items.length > 0)
          this.tipologieSediSelezionate.push(items[0]);
      }
    }));
    this.init()
  }

  setData(item, activeid?: string) {
    this.selected = item;
    this.selected['famiglia'] = this.selected['famiglia'] ?? {};
    this.dump = this.fulladdr(item);
    this.showaddform = isNaN(item.id);
    this.editable = !isNaN(item.id);
    this.selected['ruoloappoggio'] = this.type?.toUpperCase();

    this.titleservice.setTitle(this.selected['fullName'] ?? this.selected?.nominativo);
    this.compilaForm(item);
    this.CrudService.InitObjects(this.selected, this.environment.ClientiAddOn['initObj']);
    this.filestore.SetListaFile(item.files);
    this.filestore.SelectSection('clienti');
    this.hasInterventi = (this.ClientiAddOn.interventi == true) && this.environment.Modules.Interventi && !this.permission.isOperativeRole('C');
    if (this.ClientiAddOn['provinciaArray']) {
      this.apiPaths.ClassicGet('/settings/province').subscribe(data => {
        this.Provincie = data.filter(x => !(this.authenticationService.currentUserValue['regioni']?.length > 0) || this.authenticationService.currentUserValue['regioni']?.findIndex(y => y == x.regione_id) > -1)
        this.Provincia = this.Provincie.find(x => x.id == this.selected.provincia || x.label?.toLowerCase() == this.selected.provincia?.toLowerCase())

      })
    }
    this.getNote()
    this.ActiveId = activeid ?? this.ActiveId;
    this.route.queryParams
      .subscribe(params => {
          Object.getOwnPropertyNames(params)?.forEach(prop => {
            this.selected[prop] = params[prop];
            console.log('copy ' + params[prop] + ' to ' + 'this.selected.' + prop)
          })
        }
      );
    if (this.ClientiAddOn.initialize)
      this.selected = this.ClientiAddOn.initialize(this.selected, this);
    this.DropdownSources = {...this.DropdownSources, ...this.selected};
    console.log("SET BUP")
    this.bup = {...this.selected};
  }

  refresh(activeid?: string) {
    if (!this.Profilo && isNaN(this.id))
      this.aziendeStore.Refresh_data();
    this.init(activeid);
  }

  init(activeid?: string) {
    if (this.idCongelamento)
      this.subscriptions.add(this.apiPaths.ClassicPost("/anagrafica/clienti/congelamento", {id: this.idCongelamento}).subscribe(item => {
        this.setData(item, activeid);
        this.aziendeStore.updateSelectedAzienda(item);
      }))
    else if (this.Profilo)
      this.subscriptions.add(this.apiRestService.getProfiloAziende().subscribe(item => {
        this.setData(item, activeid);
      }))
    else if (isNaN(this.id)) {
      this.subscriptions.add(this.aziendeStore.$selectedAzienda.subscribe((item) => {
        if (item)
          this.setData(item, activeid);
        else {
          this.selected['ruoloappoggio'] = this.type?.toUpperCase();
          this.SetProgressivo();
        }
        this.CrudService.InitObjects(this.selected, this.environment.ClientiAddOn['initObj']);
        this.selected['famiglia'] = this.selected['famiglia'] ?? {};
        this.route.queryParams
          .subscribe(params => {
              Object.getOwnPropertyNames(params)?.forEach(prop => {
                this.selected[prop] = params[prop];
                console.log('copy ' + params[prop] + ' to ' + 'this.selected.' + prop)
              })
            }
          );
        this.showaddform = true;
      }));
    } else
      this.subscriptions.add(this.apiRestService.getInfoAziende({id: this.id}).subscribe(item => {
        this.setData(item, activeid);
        this.aziendeStore.updateSelectedAzienda(item);
      }))
    this.filtrosegnalatoreInterno('');
    if ((!this.type || this.type != 'f') && this.environment.ClientiAddOn.segnalatore && !this.Profilo)
      this.filtrosegnalatore("");
  }

  cancelClick() {
    this.aziendeStore.updateEditable(false);
    this.aziendeStore.updateShowAddForm(false);
    this.submitted = false;
    if (this.Profilo || isNaN(this.id)) {
      if (this.type)
        this.router.navigate([this.route.snapshot.queryParams[' listautenti/aziende/' + this.type] || 'listautenti/aziende/' + this.type,]);
      else
        this.router.navigate([this.route.snapshot.queryParams[' listautenti/aziende '] || 'listautenti/aziende',]);
    } else
      this.location.back()
  }

  ShowRuoliAccesso() {
    var out = !this.Profilo && this.environment.ClientiAddOn.ruoliAccesso;
    this.RuoliPredefiniti?.forEach(ruolo => {
      var ruoloPresente = this.listaruoliaccessoselezionati.find(x => x.id == ruolo.id) != undefined;
      var ruoloAccesso = this.listaruoliaccesso.find(x => x.ruolo?.toLowerCase().includes(ruolo.label?.toLowerCase()));
      if (ruoloAccesso && ruoloPresente) {
        this.listaruoliaccessoselezionati = [ruoloAccesso];
        out = false;
      }
    });
    return out;
  }

  compilaForm(value: Azienda) {
    this.CredenzialiGiaInserite = value.username && value.username.length > 0;
    this.segnalatoreinternoselezionato = value.segnalatoreInterno ? [value.segnalatoreInterno] : [];
    this.selected['id_segnalatore_internoObject'] = value.segnalatoreInterno;
    this.segnalatoreselezionato = value.segnalatore ? [value.segnalatore] : [];
    this.commercialeselezionato = value.commerciale ? [value.commerciale] : [];
    this.listaruoliaccessoselezionati = value?.ruoliAccessoObject;

    this.selectedItems = Object.assign([], value?.tipiObject);

    this.ruoloCliente = this.selected?.id ? value?.ruoliObject : (environment.ClientiAddOn['RuoloDefault'] && !this.type ? [environment.ClientiAddOn['RuoloDefault']] : []);
    if (value && value.id)
      this.tipologieSediSelezionate = value.tipiSedeObject ?? [];
  }

  fulladdr(cliente: Azienda): string {
    return (cliente?.indirizzo ? cliente.indirizzo : "") + (cliente?.citta ? ("," + cliente.citta) : "") + (cliente?.provincia ? ("," + cliente.provincia) : "");
  }

  getDaForm(): Azienda {
    var nuovo = Object.assign({}, this.selected);
    if (!environment.ClientiAddOn['SezioniInfo']) {
      nuovo.id_segnalatore = this.segnalatoreselezionato?.find(() => true)?.id ?? this.selected?.segnalatore?.id;
      nuovo.id_segnalatore_interno = this.segnalatoreinternoselezionato?.find(() => true)?.id;
      nuovo.id_commerciale = this.selected?.commerciale?.id ?? this.commercialeselezionato?.find(() => true)?.id;
      nuovo.tipi = [...(this.selectedItems?.map(x => x.id) ?? [])];
      nuovo.ruoliAccesso = [...(this.listaruoliaccessoselezionati?.map(x => x.id) ?? [])];
      nuovo.provincia = this.Provincia?.id ?? this.selected?.provincia;
    }
    nuovo.tipiSede = [...(this.tipologieSediSelezionate?.map(x => parseInt(x.id)))];
    nuovo.ruoli = [...(this.ruoloCliente?.map(x => x.id) ?? []), ...(this.type ? [this.type.toUpperCase()] : [])];
    nuovo['stato'] = nuovo['dataInserimento'] ? 177 : nuovo['stato']
    nuovo['agente'] = this.permission.isntOperativeRole('AG') ? nuovo['agente'] : this.authenticationService.currentUserValue['agente'];
    if (this.environment.ClientiAddOn['map']) {
      nuovo = this.environment.ClientiAddOn['map'](nuovo, {}, this);
    }
    return nuovo;
  }

  filtrosegnalatore(item: string) {
    this.aziendeStore.getListaAziende(new RicercaPaginazione(item, 0, 1, environment.ClientiAddOn['tipoSegnalatore']));
  }

  filtrosegnalatoreInterno(item: string) {
    if (item.length >= 3) {
      this.personaleStore.getListaPersonale(new RicercaPaginazione(item, 0, 1));
    }
  }

  filtroCommerciale(item: string) {
    if (item.length >= 3) {
      this.personaleStore.getListaPersonale(new RicercaPaginazione(item, 0, 1));
    }
  }

  Send(close?: boolean, congela?: boolean, func?: () => void, noReload?: boolean) {
    var company = this.getDaForm();
    if (this.environment.ClientiAddOn['validate'] && !this.environment.ClientiAddOn['validate'](company, this)) {
      return
    }
    if (!this.campoUtility.ValidateError(this.selected, environment.ClientiAddOn['SezioniInfo'])) {
      return
    }


    if (this.environment.ClientiAddOn['externalValidation'] && !this.environment.ClientiAddOn['externalValidation'](this.selected, this.apiPaths, this.toastService)) {
      return
    }
    ;


    if ((this.selected?.ConfermaPassword && this.selected?.ConfermaPassword.length > 0) && this.selected?.ConfermaPassword != this.selected?.password) {
      this.toastservice.warning("Le password non corrispondono");
      return;
    }
    var company = this.getDaForm();

    company.congelamento = congela ?? false;
    var bup = Object.assign({}, company);
    if (this.environment.ClientiAddOn['map']) {
      company = this.environment.ClientiAddOn['map'](company, bup, this);
    }
    if (this.Profilo) {
      if (company.id) {
        this.apiRestService.updateCompanyProfile(company).subscribe((data) => {
          this.refresh();
          this.toastService.success("Modifiche apportate con successo!", "Yess!!");
          if (close)
            this.cancelClick();
        });
      }
      return;
    }

    if (company.id) {
      this.apiRestService.updateCompany(company).subscribe((data) => {
        if (!noReload)
          this.aziendeStore.getListaAziende(new Paginazione(1, 50));
        if (!func)
          this.toastService.success("Modifiche apportate con successo!", "Yess!!");
        if (this.environment.ClientiAddOn['resetCongelamento'] && congela) {
          company.checks = [];
          this.apiRestService.updateCompany(company).subscribe((data) => {
            if (close)
              this.cancelClick();
          });
        }
        if (close && !congela)
          this.cancelClick();
        if (func)
          func();
      });
    } else if (!company.id) {
      this.apiRestService.addNewCompany(company).subscribe((data) => {
        this.id = data.id;
        this.subscriptions.add(this.apiRestService.getInfoAziende({id: data.id}).subscribe(item => {
          this.setData(item);
          // if (bup.referenti?.length > 0) {
          //   bup?.referenti?.forEach(x => {
          //     x.cliente = data.id;
          //     this.apiPaths.ClassicPost('/anagrafica/clienti/referenti/add', x).subscribe();
          //   })
          // }
          this.aziendeStore.updateSelectedAzienda(item);
        }))
        if (close) {
          this.aziendeStore.getListaAziende(new Paginazione(1, 50));
          this.cancelClick();
        }
      });
    }
  }

  GetFiltro(filter) {
    return Object.assign(filter ?? {}, {id_cliente: this.id, magazzino: this.selected['magazzino']});

  }

  saveClick(close?: boolean, congela?: boolean) {
    this.cdr.detectChanges();
    if (this.ClientiAddOn.geolocalizzazione && this.dump != this.fulladdr(this.selected) && this.fulladdr(this.selected) != "")
      this.apiRestService.getCoordinate(this.fulladdr(this.selected)).subscribe(response => {
        if (response?.results?.length > 0 && response?.results[0]?.geometry?.location) {
          this.selected.lat = response.results[0].geometry.location.lat;
          this.selected.lon = response.results[0].geometry.location.lng;
          this.Send(close, congela);
        }
      })
    else
      this.Send(close, congela);
  }

  deleteClick() {
    this.aziendeStore.deleteCompany(this.selected);
    this.cancelClick();
  }

  onFileChanged() {
    this.refresh();
  }

  enable(co) {
    this.apiRestService.enableAziende(co).subscribe(data => this.refresh())
  }

  disable(co) {
    if (!confirm("Sei sicuro di voler disabilitare questo cliente?")) return;
    this.apiRestService.disableAziende(co).subscribe(data => this.refresh())
  }

  AddAdhoc(co, force?: boolean) {
    if (this.selected['tipoSocieta'] == 'E') {
      this.selected['codice_univoco'] = "XXXXXXX"
    }

    if (this.environment.ClientiAddOn['validate'] && !this.environment.ClientiAddOn['validate'](this.getDaForm(), this, true, force)) {
      return
    }

    this.Send(false, false, () => {
      this.apiRestService.SendToAdhoc(co).subscribe(data => this.refresh())
    })
  }


  SelectedChecks(check) {
    var resp = [...(check.foglie?.filter(x => x.risposta || x.isNota) ?? [])];
    check.figli?.forEach(x => {
      resp = [...resp, ...this.SelectedChecks(x)]
    })
    return resp;
  }


  ChecklistChanged(questionario: Todo[]) {
    let risposteSelezionate: Check[] = [];
    questionario.forEach(todo => {
      risposteSelezionate = [...risposteSelezionate, ...this.SelectedChecks(todo)];
    })
    this.selected.checks = risposteSelezionate;
  }

  OpenCongelamento(co: any) {
    const splittedApiUrl = environment.apiUrl.split('/');
    const route = (environment['baseHref'] || splittedApiUrl.length > 4) && !location.origin.includes('localhost') && !location.origin.includes('192.168') ? `/${environment['baseHref'] ?? splittedApiUrl[3]}/listautenti/formazienda/` : '/listautenti/formazienda/'
    console.log(route + (this.type ?? '0') + '/' + this.selected.id + "/" + co.id.toString());
    window.open(route + (this.type ?? '0') + '/' + this.selected.id + "/" + co.id.toString());


  }

  OnNominativoChange() {
    if (!this.showaddform) return;
    this.SetProgressivo();
  }

  SetProgressivo() {
    var value = this.environment.ClientiAddOn['CustomCodice'];
    if (!value) return;
    this.selected.statoCivile = value;
    if (value.includes('${progressivo}') && !this.selected["idEc"]) {
      this.apiPaths.ClassicGet('/anagrafica/clienti/progressivo').subscribe(progressivo => {

        this.selected.statoCivile = this.selected.statoCivile.replace('${progressivo}', progressivo.toString());
        this.selected["idEc"] = progressivo

      });
    } else if (value.includes('${progressivo}'))
      this.selected.statoCivile = this.selected.statoCivile.replace('${progressivo}', this.selected["idEc"].toString());
    if (value.includes('${iniziali}')) {
      var val = this.selected.nominativo.split(' ');
      var iniziali = "";
      val.forEach((a: string) => {
        iniziali += a.charAt(0)
      });
      this.selected.statoCivile = this.selected.statoCivile.replace('${iniziali}', iniziali.toString());
    }

  }

  CustomButton(x: { item: any, button: any, component: FormAziendaComponent }) {
    if (x.button.type == 'Salva') {
      x.component.saveClick(x.button.close);
      return true;
    } else if (x.button.type == 'Congela') {
      x.component.saveClick(x.button.close, true);
      return true;
    }
    return true;
  }

  ChangeHandler(item: { OnChange: string; Event: any }) {
    switch (item.OnChange) {
      case 'OnFilesChange':
        this.refresh();
        break;
      case 'Save':
        this.saveClick(false);
        break;

    }
    if (this.ClientiAddOn.onChange)
      this.ClientiAddOn.onChange(item, this);
  }

  FilterHandler(event) {

  }


  getSingleNota(list, tipologia: string) {
    return list.filter(x => x.tipologia == tipologia).map(y => y.note)
  }

  getNote() {
    if (environment.ClientiAddOn['Tabs']?.findIndex(x => x.params && x.params['tipo'] == 'E' && x.params['filter'] == "AN") > -1) {
      const source = [{id: 'AP', label: 'Anamnesi Psichiatrica', oggetto: 'notePsichiatrica'}, {
        id: 'AS',
        label: 'Anamnesi Sociale',
        oggetto: 'noteSociale'
      }, {id: 'AF', label: 'Anamnesi Familiare', oggetto: 'noteFamiliare'}, {
        id: 'PP',
        label: 'Potenziale pericolosità per sé e per gli altri',
        oggetto: 'notePotenziale'
      }, {id: 'ADS', label: 'Anamnesi dello Sviluppo', oggetto: 'noteSviluppo'}, {
        id: 'AM',
        label: 'Anamnesi Medica',
        oggetto: 'noteMediche'
      }]
      this.apiPaths.ClassicPost('/task/task/list', {
        page: 0,
        size: 10,
        periodo: false,
        tipo: 'E',
        cliente: this.selected.id
      }).subscribe(
        data => {
          let list = data.data.filter(x => x['tipoObject']?.id == "AN" && x.cliente == this.selected.id)
          source.forEach(x => {
              this.selected[x.oggetto] = ""
              this.getSingleNota(list, x.id).forEach(
                y => this.selected[x.oggetto] += y += '\n'
              )
            }
          )
        });
    }

  }

  TaskTabHeader(tab){
    return tab.headers?.filter(x=>!x.oggetti.includes['clienteObject'])
  }

  FindSupermarket(cliente){
    this.toastService.warning("Attenzione l'operazione può richiedere alcuni minuti", "Ricerca in corso..." )
    this.apiPaths.ClassicPost('/anagrafica/clienti/sede/import', {cliente: cliente.id, tipiSede: this.tipologieSedi?.map(x => x.id)}).subscribe(data => {
      this.toastService.success("Ricerca completata" )
    })

  }

}


@Pipe({
  name: 'myfilter',
  pure: false
})
export class ButtonsPipe implements PipeTransform {
  transform(items: any[], ActiveId: boolean): any {
    if (!items || ActiveId != false)
      return items;
    return items.filter(x => x.tabs.includes(ActiveId))
  }
}
